import React from 'react';
import { Link } from "react-router-dom";

import Book from './components/book/Book';
//import BlogHome from './components/BlogHome';
import ForumHome from './components/ForumHome';
//import ProfilHome from './components/ProfilHome';
import VideoHome from './components/medias/VideoHome';
import PhotoHomeCreator from './components/medias/PhotoHomeCreator';
import PhotoHomeMember from './components/medias/PhotoHomeMember';
import StatusHome from './components/StatusHome';
import {Button} from "../../components/Button";
import Title from "../../components/Title";
import createLink from "../../../libs/createLink";
import {Helmet} from "react-helmet";
import {canonical} from "../../../libs/helper";

import Advertising from "../../components/Advertising/Advertising";

const Home = () =>{

    return (
        <div id="home">
            <Helmet>
                <title>Voissa, l'épanouissement par l'exhibition et le sexe</title>
                <meta name="description"
                      content={"Voissa est une source d'épanouissement à travers l'exhibition, le partage et la sensualité. Envoyez vos contributions photos ou vidéos amateurs, créez un blog coquin public ou privé, rencontrez et réalisez de belles expériences avec les Voissanautes."}/>
                <meta name="keywords"
                      content={"voissa, sexe amateur, video amateur, video sexe amateur, amateur sexe"}/>
                <link rel="canonical" href={canonical("", "", "home")} />
            </Helmet>
            <div id="topMedia">
                <div className="container">
                    <Advertising sizeMobile={"300x100"} className={"center"} />
                    <div id="medias-card" className="card big">
                        <section>
                            <Title className={"mb-16"} heading={"heading-2"} display={"display-2"}>Photos du moment</Title>
                            <div className={"title-wrapper"}>
                                <Title heading={"heading-3"} display={"display-4"}>Par les voissa créateurs</Title>
                                <Link to={`${createLink('photos')}?isCreator=true`}>Voir toutes leurs photos</Link>
                            </div>
                            <PhotoHomeCreator/>
                            <div className={"title-wrapper"}>
                                <Title heading={"heading-3"} display={"display-4"}>Par l’ensemble des
                                    voissanautes</Title>
                                <Link to={createLink('photos')}>Voir toutes les photos</Link>
                            </div>
                            <PhotoHomeMember/>
                        </section>
                        {/*<section>
                                <div className={"title-wrapper subtitle"}>Des profils à suivre</div>
                                <ProfilHome/>
                            </section>*/}
                        <section>
                            <div className={"title-wrapper"}>
                                <Title heading={"heading-2"} display={"display-2"}>Vidéos du moment</Title>
                                <Link to={createLink('videos')}>Voir toutes les vidéos</Link>
                            </div>
                            <VideoHome/>
                        </section>
                    </div>
                </div>
            </div>
            <div id="status">
                <StatusHome/>
            </div>
            <div id="forums">
                <div className="container">
                    <div className="title-container">
                        <div  className="section-title">Actuellement sur les forums</div>
                        <Button size={"big"}
                                btnStyle={"primary"}
                                corner={"btn-rounded"}
                                to={createLink('forum')}
                                content={"VOIR LES FORUMS"}/>
                    </div>
                    <ForumHome/>
                </div>
            </div>
            {/*<div id="blogs">
                    <div className="container">
                        <div className="col left">
                            <div className="section-title">Les derniers <br/>billets
                                publiés</div>
                            <Button size={"big"}
                                    btnStyle={"primary"}
                                    corner={"btn-rounded"}
                                    to={createLink('articles')}
                                    content={"VOIR TOUS LES ARTICLES"}/>
                        </div>
                        <BlogHome/>
                    </div>
                </div>
                */}
            <div id="histoire">
                <div className="container">
                    <div className={"flex-jc-sb"}>
                        <Title heading={"heading-2"} className="section-title">
                            Les dernières histoires érotiques
                        </Title>
                        <Button size={"big"}
                                className={"mt-16"}
                                btnStyle={"primary"}
                                corner={"btn-rounded"}
                                to={createLink('stories')}
                                content={"VOIR TOUTES LES HISTOIRES"}/>
                    </div>
                    <div className="book-wrapper">
                        <Book/>
                    </div>
                </div>
            </div>
            <div className={"container"}>
                <div className={"footer-home"}>
                    <p>Voissa est né pour permettre à ses membres de trouver un lieu dans lequel ils pourraient
                        discuter, partager et se dévoiler en toute liberté. En 1999 le web débute, peu de sites
                        répondent à cette demande et pourtant Voissa est déjà là, ce petit jardin secret fréquenté
                        par quelques centaines de personnes.</p>

                    <p>Depuis lors Voissa a évolué et bien entendu grossi. Plus de 100 000 personnes viennent
                        désormais quotidiennement profiter de notre communauté, pour se montrer ou simplement
                        regarder, pour discuter, débattre, commenter ou simplement lire.</p>

                    <p>Les années n'ont pas dévié Voissa de son objectif, restant fidèle à son ADN, continuant de
                        faire de sa communauté un lieu ou règne le respect, la bonne humeur et l'envie commune de
                        voir ses membres s'épanouir sexuellement.</p>

                    <p>En vous baladant sur Voissa vous trouverez des photos et vidéos sexuelles. La liberté c'est
                        aussi de permettre à chacun de s'exprimer, qu'il souhaite publier une vidéo <a
                            href="https://www.jacquieetmicheltv.net" target="_blank"
                            rel="noopener noreferrer">porno</a> ou plus sensuelle, chacun utilise son profil comme
                        il l'entend.</p>
                </div>
            </div>

        </div>
    );
}

export default Home;